export const CREATION_TYPE = 'CREATION_TYPE';
export const FILE_SELECTOR = 'FILE_SELECTOR';
export const INITIAL_MODE = 'INITIAL_MODE';
export const SUMMARY = 'SUMMARY';
export const WORKSPACE_NAME = 'WORKSPACE_NAME';
export const WORKSPACE_SELECTION = 'WORKSPACE_SELECTION';
